import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var revamp = config.revamp;
var accounts = "accounts/";
var account = "account/";
var dev = "dev/";
var guestlogin = "guestlogin/";
var guest = "guest/";
var otp = "otp/";
var devs = config.kambalaBase;
var devutil = "devutil/";
var LoginFlowConfigURL = {
    loginBaseUrl: config.jmw + config.jmw_login + accounts,
    loginBaseKambalaUrl: config.jmwedel + devs + config.jmw_login + account,
    loginBaseKambalaloginHelpUrl: config.jmwedel + devs + config.jmw_login + "loginhelp/",
    clientLoginValidateUser: "validateuser/",
    clientLoginValidatePassword: "validatepassword/",
    clientLoginvalidateOTP: "2falogin/",
    setPassword: "setpassword/",
    clientValidateOTP: "/forgotpassword/validateotp",
    unblockUser: "unblockuser/",
    clientForgetUserID: "forgotuserid",
    generateOTP: otp,
    mock: "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/",
    guestBaseAPI: "".concat(dev).concat(revamp).concat(guestlogin),
    guestRealBaseAPI: config.jmw + revamp + config.jmw_content + guest,
    accountCheck: "status",
    validateMPIN: "pin/validate",
    guestSetMPIN: "pin/register",
    guestForgotSetMPIN: "update-pin",
    checknaddEmail: "email/otp-register",
    guestverifyEmail: "email/otp-validate",
    addAccount: "otp-register",
    forgotPIN: "forget-mpin",
    guestValidate: "otp-validate",
};
export default LoginFlowConfigURL;
